import React from "react";
import { ProductPreloader } from "../../Preloaders";
import "./about.scss";
const AboutContainer = () => {
    return (
        <>
         
        </>
    );
};

export default AboutContainer;
